// src/data/products.js

// ── Recipient Categories (who is the gift for) ───────────────────
export const RECIPIENT_CATEGORIES = [
  { id: 'girlfriend',   label: 'For Girlfriend',    emoji: '💝', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_328,w_369,x_9,y_10/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',   color: 'from-pink-500 to-rose-600',     description: 'Surprise her with love'     },
  { id: 'boyfriend',   label: 'For Boyfriend',      emoji: '💙', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_333,w_376,x_387,y_7/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',   color: 'from-blue-500 to-indigo-600',   description: 'Show him you care'          },
  { id: 'wife',        label: 'For Wife',            emoji: '💍', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/t_imgbuilder/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-rose-500 to-pink-700',     description: 'Because she deserves it'    },
  { id: 'husband',     label: 'For Husband',         emoji: '🤵', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_329,w_371,x_1153,y_12/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-slate-600 to-gray-800',    description: 'Celebrate your love'        },
  { id: 'female-friend',label:'For Female Friend',   emoji: '👭', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_315,w_357,x_7,y_350/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-purple-500 to-pink-600',   description: 'Gifts for your bestie'      },
  { id: 'male-friend', label: 'For Male Friend',     emoji: '👬', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_323,w_369,x_387,y_350/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-teal-500 to-cyan-700',     description: 'For your best bro'          },
  { id: 'sister',      label: 'For Sister',          emoji: '👧', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_323,w_361,x_777,y_350/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png', color: 'from-orange-400 to-pink-600',   description: 'Sisters are special'        },
  { id: 'brother',     label: 'For Brother',         emoji: '👦', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_322,w_368,x_1155,y_348/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png', color: 'from-amber-500 to-orange-700',  description: 'For your favourite bro'     },
  { id: 'mother',      label: 'For Mother',          emoji: '👩‍❤️‍👦', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_333,w_368,x_7,y_681/e_enhance/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png', color: 'from-yellow-400 to-orange-600', description: 'She gave you everything'    },
  { id: 'father',      label: 'For Father',          emoji: '👨', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/c_crop,g_north_west,h_329,w_370,x_390,y_682/e_gen_restore/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-green-500 to-teal-700',    description: 'For the strongest person'   },
  { id: 'couple',      label: 'For Couples',         emoji: '👫', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/ar_3:4,c_crop,g_north_west,h_325,w_366,x_775,y_685/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-rose-600 to-red-700',      description: 'Perfect pair gifts'         },
  { id: 'anniversary', label: 'Anniversary',         emoji: '🥂', image: 'https://res.cloudinary.com/defnhgwsd/image/upload/ar_3:4,c_crop,g_north_west,h_334,w_373,x_1150,y_680/e_gen_restore/e_brightness:48/ChatGPT_Image_May_1_2026_06_08_59_PM_gmuebv.png',  color: 'from-yellow-500 to-rose-600',   description: 'Celebrate milestones'       },
];

// ── Product Type Categories (used for filters & merchant category) ──
export const CATEGORIES = [
  { id: 'all',          label: 'All Gifts',        icon: '🎁' },
  { id: 'personalized', label: 'Personalized',     icon: '✨' },
  { id: 'handmade',     label: 'Handmade',         icon: '🤝' },
  { id: 'surprise',     label: 'Surprise Box',     icon: '📦' },
  { id: 'anniversary',  label: 'Anniversary',      icon: '💍' },
  { id: 'valentines',   label: "Valentine's",      icon: '❤️' },
  { id: 'jewelry',      label: 'Jewellery',        icon: '💎' },
  { id: 'clothing',     label: 'Clothing',         icon: '👗' },
  { id: 'home-decor',   label: 'Home Décor',       icon: '🏠' },
  { id: 'food',         label: 'Food & Sweets',    icon: '🍫' },
  { id: 'stationery',   label: 'Cards & Stationery',icon: '📝'},
  { id: 'experience',   label: 'Experiences',      icon: '🎉' },
];

// ── Hero Slides — with real romantic images ────────────────────────
export const HERO_SLIDES = [
  {
    id: 1,
    tag: 'New Collection 2024',
    headline: 'Love Gifted',
    highlight: 'Beautifully',
    subtitle: 'Handpicked gifts for every milestone — from personalised surprises to luxury couple hampers.',
    cta: 'Explore Gifts',
    ctaLink: '/products',
    image: 'https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=900&q=85',
  },
  {
    id: 2,
    tag: 'Personalized Just For Her',
    headline: 'Your Story,',
    highlight: 'Our Craft',
    subtitle: 'Custom star maps, engraved keychains, and illustrated portraits — all made with love.',
    cta: 'For Girlfriend',
    ctaLink: '/products?recipient=girlfriend',
    image: 'https://images.unsplash.com/photo-1474552226712-ac0f0961a954?w=900&q=85',
  },
  {
    id: 3,
    tag: 'Because She Deserves It',
    headline: 'Made to Make',
    highlight: 'Her Smile',
    subtitle: 'Romantic gift hampers, handmade keepsakes, and surprise boxes — curated with pure love.',
    cta: 'Shop Now',
    ctaLink: '/products',
    image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=900&q=85',
  },
  {
    id: 4,
    tag: 'Mystery & Surprise',
    headline: 'Open a Box',
    highlight: 'Full of Love',
    subtitle: 'Our mystery surprise boxes are curated with 5–7 romantic gifts, each one a delightful reveal.',
    cta: 'Get Surprised',
    ctaLink: '/products?category=surprise',
    image: 'https://images.unsplash.com/photo-1512909006721-3d6018887383?w=900&q=85',
  },
  {
    id: 5,
    tag: 'Handcrafted with Heart',
    headline: 'Made by Hand,',
    highlight: 'Sent with Love',
    subtitle: 'Each product handcrafted by talented artisans. No two gifts alike — just like your relationship.',
    cta: 'Shop Handmade',
    ctaLink: '/products?category=handmade',
    image: 'https://c8.alamy.com/comp/GMERC6/group-photo-of-happy-indian-family-in-ganesh-festival-happy-indian-GMERC6.jpg',
  },
];

// ── Testimonials ────────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Priya & Arjun',
    city: 'Mumbai',
    text: 'We ordered the Personalized Star Map for our anniversary and it was absolutely breathtaking! CoupleCart made our day truly special.',
    rating: 5,
    avatar: 'PA',
    product: 'Personalized Star Map',
  },
  {
    id: 2,
    name: 'Meera Sharma',
    city: 'Bangalore',
    text: 'The Mystery Surprise Box was such a fun experience! Every item inside was thoughtful and romantic. Will definitely order again!',
    rating: 5,
    avatar: 'MS',
    product: 'Mystery Surprise Box',
  },
  {
    id: 3,
    name: 'Rahul & Sneha',
    city: 'Delhi',
    text: 'The packaging itself is so premium. The Love Jar was handcrafted beautifully and the notes inside were so touching. 10/10!',
    rating: 5,
    avatar: 'RS',
    product: 'Handmade Love Jar',
  },
];

// ── Sample product ──────────────────────────────────────────────────
export const PRODUCTS = [
  {
    id: 'p9',
    name: 'Handmade Floral Bookmark',
    description: 'A beautiful hand-painted bookmark with delicate floral designs and the quote "Just One More Chapter".',
    price: 100,
    originalPrice: 149,
    category: 'handmade',
    recipient: ['girlfriend', 'female-friend', 'sister', 'mother'],
    rating: 4.9,
    reviews: 12,
    badge: 'Handmade',
    image: 'https://i.ibb.co/2Yc6bx0Q/Chat-GPT-Image-Apr-9-2026-12-43-12-AM.png',
    images: ['https://i.ibb.co/2Yc6bx0Q/Chat-GPT-Image-Apr-9-2026-12-43-12-AM.png'],
    tags: ['bookmark', 'handmade', 'floral'],
    stock: 10,
    isNew: true,
    isFeatured: true,
  },
];
